module.exports = __webpack_public_path__ + "img/diamonds-3x.9bd150d1.png";